import React, { useState } from 'react';
import { MdMenu } from 'react-icons/md';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { userLogoutOp } from '../redux/operations/user.operations';
import Profile from '../Components/profile/Profile';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { MdKeyboardArrowUp } from 'react-icons/md';
const TopNavbar = ({ setOpen }) => {
  const { role } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(userLogoutOp());
    localStorage.removeItem('userAuthToken');
    localStorage.removeItem('locationIp');
    navigate('/seva-login');
  };
  const [showDropdown, setShowDropdown] = useState(false);
  const [showFormDropdown, setShowFormDropdown] = useState(false);

  const settingsMenusList = [
    {
      name: 'Portal Update',
      menus: [
        { name: 'News', link: 'news' },
        { name: 'Users', link: 'all-users' },
        { name: 'Images', link: 'images' },
        { name: 'Videos', link: 'videos' },
        { name: 'AMO Calendar', link: 'calendar' },
        {
          name: 'Forms',
          subMenus: [
            { name: 'General Grievance', link: '/' },
            { name: 'TTD Darshan Request', link: '/' },
            { name: 'CMRF/PMRF Application', link: '/' },
          ],
        },
      ],
    },
  ];

  {
    console.log(process.env.REACT_APP_S3_URL);
  }

  return (
    <nav
      className="w-full flex items-center justify-between bg-blueBg shadow-xl sticky top-0 z-[998] px-5"
      onMouseLeave={() => {
        setShowDropdown(false);
        setShowFormDropdown(false);
      }}
    >
      {/* Left Section: Logo, Title & Mobile Menu Icon */}
      <div className="flex items-center">
        {/* Logo */}

        <div className="h-14 w-14 md:h-20 md:w-18 flex-shrink-0 py-2">
          <img
            src={`${process.env.REACT_APP_S3_URL}/logo.png`}
            alt="SEVA Logo"
            className="h-full w-full object-contain"
          />
        </div>

        <div className="flex items-center space-x-1 md:space-x-2 leading-tight">
          <span className="text-white font-bold md:font-extrabold text-sm md:text-2xl font-montserrat md:tracking-[0.3em]">
            SEVA
          </span>
          <span className="text-white mt-1 italic font-light text-sm md:text-md md:text-base font-[cursive] font-montserrat">
            Grievance Portal
          </span>
        </div>
      </div>

      {/* Right Section: Nav Links and Profile (hidden on small screens) */}
      <div className="flex items-center">
        <div className="hidden xl:flex items-center space-x-6 text-white font-medium">
          {/* Grievance Operator */}
          {role === 'Grievance-Data-Entry-Operator' && (
            <>
              <NavLink to="/gms" className="relative px-2 py-1 group">
                <span className="hover:text-gray-300 transition duration-300">
                  My Request
                </span>
                <span className="absolute left-0 bottom-0 w-0 h-[0.5px] bg-gray-400 group-hover:w-full transition-all duration-300" />
              </NavLink>

              <NavLink to="/AddGms" className="relative px-2 py-1 group">
                <span className="hover:text-gray-300 transition duration-300">
                  Add Request
                </span>
                <span className="absolute left-0 bottom-0 w-0 h-[0.5px] bg-gray-400 group-hover:w-full transition-all duration-300" />
              </NavLink>
            </>
          )}

          {/* Web Portal Data Entry */}
          {role === 'Web-Portal-Data-Entry' && (
            <>
              {['news', 'videos', 'images'].map((item) => (
                <NavLink
                  key={item}
                  to={`/${item}`}
                  className="relative px-2 py-1 group capitalize"
                >
                  <span className="hover:text-gray-300 transition duration-300">
                    {item}
                  </span>
                  <span className="absolute left-0 bottom-0 w-0 h-[0.5px] bg-gray-400 group-hover:w-full transition-all duration-300" />
                </NavLink>
              ))}
            </>
          )}

          {/* Dashboard */}
          {(role === 'Super-Admin' ||
            role === 'Admin' ||
            role === 'Grievance-Admin-Access') && (
            <NavLink
              to="/dashboard"
              className="relative px-2 py-1 group font-montsettat text-sm tracking-[0.1em]"
            >
              <span className="hover:text-gray-300 transition duration-300">
                Dashboard
              </span>
              <span className="absolute left-0 bottom-0 w-0 h-[0.5px] bg-gray-400 group-hover:w-full transition-all duration-300" />
            </NavLink>
          )}

          {/* Admin Access Sections */}
          {(role === 'Super-Admin' ||
            role === 'Admin' ||
            role === 'Grievance-Admin-Access' ||
            role === 'Grievance-Manager-Access') && (
            <>
              {[
                { name: 'Grievance', link: 'gms' },
                { name: 'Job Request ', link: 'job-requests' },
                { name: 'MP Lads', link: 'budget' },
                { name: 'TTD Calendar', link: 'ttd-calendar/approved-list' },
              ].map(({ name, link }) => (
                <NavLink
                  key={link}
                  to={`/${link}`}
                  className="relative px-2 py-1 group font-montsettat text-sm tracking-[0.1em]"
                >
                  <span className="hover:text-gray-300 transition duration-300">
                    {name}
                  </span>
                  <span className="absolute left-0 bottom-0 w-0 h-[0.5px] bg-white group-hover:w-full transition-all duration-300" />
                </NavLink>
              ))}
            </>
          )}

          {/* Dropdown Menu for Portal Update */}
          {(role === 'Super-Admin' || role === 'Admin') && (
            <div className="relative">
              <button
                onClick={() => setShowDropdown((prev) => !prev)}
                className="flex items-center space-x-1 hover:text-gray-300 hover:bg-transparent font-montsettat text-sm tracking-[0.1em] focus:outline-none"
              >
                <span>Portal Update</span>
                {showDropdown ? (
                  <MdKeyboardArrowUp size={20} />
                ) : (
                  <MdKeyboardArrowDown size={20} />
                )}
              </button>

              {showDropdown && (
                <div className="absolute top-full right-0 mt-6 w-64 bg-blueBg border border-gray-300 rounded shadow-lg z-50">
                  {settingsMenusList[0].menus.map((menu, index) => (
                    <div
                      key={index}
                      className="border-b border-gray-200 last:border-b-0"
                    >
                      {/* If it's a submenu (i.e., Forms) */}
                      {menu.subMenus ? (
                        <div className="relative">
                          <button
                            onClick={() => setShowFormDropdown((prev) => !prev)}
                            className="w-full flex justify-between items-center px-4 py-2 text-white hover:bg-gray-700 font-montsettat text-sm tracking-[0.1em]"
                          >
                            <span>{menu.name}</span>
                            {showFormDropdown ? (
                              <MdKeyboardArrowUp size={18} />
                            ) : (
                              <MdKeyboardArrowDown size={18} />
                            )}
                          </button>

                          {showFormDropdown && (
                            <div className="pl-6">
                              {menu.subMenus.map((subMenu, subIndex) => (
                                <NavLink
                                  key={subIndex}
                                  to={subMenu.link}
                                  onClick={() => {
                                    setShowFormDropdown(false);
                                    setShowDropdown(false);
                                  }}
                                  className="block px-3 py-2 text-white hover:bg-gray-700 font-montsettat text-xs tracking-[0.1em]"
                                >
                                  {subMenu.name}
                                </NavLink>
                              ))}
                            </div>
                          )}
                        </div>
                      ) : (
                        <NavLink
                          to={`/${menu.link}`}
                          onClick={() => setShowDropdown(false)}
                          className="block px-4 py-2 text-white hover:bg-gray-700 font-montsettat text-sm tracking-[0.1em]"
                        >
                          {menu.name}
                        </NavLink>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>

        <Profile />
        {/* Mobile Menu Icon */}
        <div className="xl:hidden cursor-pointer" onClick={() => setOpen(true)}>
          <MdMenu size={30} className="text-white" />
        </div>
      </div>
    </nav>
  );
};

export default TopNavbar;
